import NavBar from "components/NavBar";
import TerraCastilla from "components/TerraCastilla";

const Tour = () => {
  return (
    <div className="app">
      <NavBar />
      <TerraCastilla />
    </div>
  );
};

export default Tour;
